var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svv-items-list-type-switch-container"},[(
      _vm.widgetSettings.widget_style_settings.ew_available_lists &&
      _vm.widgetSettings.widget_style_settings.ew_available_lists.length > 1
    )?_c('div',{staticClass:"svv-items-list-type-switch-inner-container"},[(
        _vm.widgetSettings.widget_style_settings.ew_available_lists.includes(
          'events'
        )
      )?_c('div',{staticClass:"svv-switch-toggle-item",class:{ active: _vm.openItemsList === 'events' },on:{"click":function($event){$event.preventDefault();return (() => _vm.onSwitchChange('events')).apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t("mainWidget.widgetEventsListSwitchLabel"))+" ")]):_vm._e(),(
        _vm.widgetSettings.widget_style_settings.ew_available_lists.includes(
          'bundles'
        )
      )?_c('div',{staticClass:"svv-switch-toggle-item",class:{ active: _vm.openItemsList === 'bundles' },on:{"click":function($event){$event.preventDefault();return (() => _vm.onSwitchChange('bundles')).apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t("mainWidget.widgetBundlesListSwitchLabel"))+" ")]):_vm._e()]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }